import React from 'react';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import { Seal,CircleSlice8  } from 'mdi-material-ui';
import { makeStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import StepContent from '@material-ui/core/StepContent';
import { Button } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
    },
    button: {
        marginTop: theme.spacing(1),
        marginRight: theme.spacing(1),
    },
    resetContainer: {
        padding: theme.spacing(3),
    },
    label:{
        color:'white !important'
    }
}));

function getSteps() {
    return ['Ranked within the top 5% of Graduating Class', 'Received Excellent Students Scholarship from Kanoon Farhangi Amoozesh Ghalamchi [2017-2019]', 'Best Representation in Iran Open 2018',<div>9<sup>th</sup> Place in the ACM/ICPC 2018 Competition</div>,'Qualified for ACM/ICPC Competitions Among K. N. Toosi University’s Teams for 2016 and 2018','Received Full Tuition Fee Waiver Scholarship from K. N. Toosi University of Technology','Ranked within the top 1% of Iranian University Entrance Exam for Bachelor’s Degree in Computer Engineering'];
}

function getStepContent(step) {
    switch (step) {
        case 0:
            return ``;
        case 1:
            return '';
        case 2:
            return <div> <div>Using Q-Learning and Other Algorithms in the Team Description Paper</div> <pre>League: Soccer 2D Simulation     Team: KN2C</pre></div>
            ;
        case 3:
            return <pre>Asia Region      Team: MSA</pre>;
        default:
            return '';
    }
}

export default function Honors() {
    const classes = useStyles();
    const [activeStep, setActiveStep] = React.useState(0);
    const steps = getSteps();

    function handleClick(index) {
        setActiveStep(index);
    }

    return (
        <div>
            <Typography component="div">
                <div style={{ display: "flex", alignItems: "center", marginLeft: 10 }}>
                    
                    <Box fontWeight="bold" fontSize={40} m={2}>
                        <div><Seal color="primary" style={{ fontSize: 40 }} /> honors and awards</div><Button color="primary" variant="contained" component="a" href="certificates.pdf" rel="noopener noreferrer" target="_blank">Certificates</Button>
                    </Box>
                </div>
            </Typography>
            <div className={classes.root}>
                <Stepper activeStep={activeStep} orientation="vertical" style={{background:'#1a1c1d'}}>
                    {steps.map((label, index) => (
                        <Step key={label}>
                            <StepLabel style={{cursor:'pointer'}} onClick={()=>handleClick(index)} classes={{label:classes.label}} StepIconComponent={()=><CircleSlice8 color="primary"/>}>{label}</StepLabel>
                            <StepContent>
                                <Typography component="div">
                                    <Box fontSize={14} m={1} style={{color:'#ffffff'}} textAlign="justify">
                                        {getStepContent(index)}
                                    </Box>
                                </Typography>
                            </StepContent>
                        </Step>
                    ))}
                </Stepper>
            </div>
        </div>
    )
}